// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fA","advertDetailContactGroup__header":"c-n_fB","advertDetailContactGroup__value":"c-n_fC"};